export const PdfEditorTabs = {
  ADD: 'addFields',
  FIELDS: 'listOfFields',
};
